import CheckImageCapture from 'features/rdc/screens/CheckImageCapture/CheckImageCapture';
import React from 'react';

export default function Page() {
  return <CheckImageCapture />;
}
